import * as React from "react"

import Paragraph from "../../design-system/paragraph"
import { classNames } from "../../utils/class-names"
import * as styles from "./index.module.scss"

interface Props {
  quote: string
  authorName?: string
  authorTitle?: string
  className?: string
}

const Blockquote = ({ quote, authorName, authorTitle, className }: Props) => {
  const footer =
    authorName && authorTitle
      ? `${authorName}, ${authorTitle}`
      : authorName || authorTitle || ""

  return (
    <blockquote className={classNames(styles.container, className)}>
      <Paragraph variant="1">{quote}</Paragraph>
      <footer className={styles.footer}>
        <Paragraph variant="1">
          <cite>{footer}</cite>
        </Paragraph>
      </footer>
    </blockquote>
  )
}

export default Blockquote
